<template>
  <app-button
    variant="primary"
    :text="text"
    :disabled="disabled"
    :block="block"
    :type="type"
    @click="$emit(appConstants.app.emitEvents.CLICK, $event)"
  >
    <slot>
      <template>{{ text }}</template>
    </slot>
  </app-button>
</template>

<script>
import AppButton from '@/views/components/app-buttons/AppButton.vue'
import appConstants from '@/constants/constants'

export default {
  name: 'PrimaryButton',
  components: { AppButton },
  emits: ['click'],
  props: {
    text: {
      type: [String, null],
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    block: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    type: {
      type: String,
      required: false,
    },
  },
  setup() {
    return {
      appConstants,
    }
  },
}
</script>
